import {connect} from "react-redux";
import TicketDetails from "./TicketDetails";
import {bindActionCreators} from "redux";
import {getLead, getLeadFilter} from "../../../../service/Lead/action";
import { selfRatingDetails, ratingSave } from "../../../../service/Dealer/action";
import { fetchTicketDetails } from "../../../../service/RaiseTicket/action";

const mapStateToProps = (state) => ({
    leadList:state.Lead.leadList,
    leadFilter:state.Lead.leadFilter,
    selfListing:state.Dealer.selfListing,
    getTicketDetails: state.RaiseTicket.getTicketDetails
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getLead,
            getLeadFilter,
            selfRatingDetails,
            fetchTicketDetails
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(TicketDetails);
